export default {
  pageTitle: '销售订单详情',
  secondTitle: '订单信息',
  remark: '备注',
  userConfirmed: '用户已确认',
  pendingConfirm: '待用户确认',
  areaTitle: '新订单确认',
  Confirmed1: '已与用户确认',
  Confirmed2: '已与用户确认只发有库存商品',
  Confirmed3: '等待所有商品准齐',
  Confirmed4: '用户取消',
  ok: '确定',
  cancelOrderReason: '请先选择取消的原因！',
  orderOperationLog: '订单操作日志',
  noLogisticsRecord: '无物流记录',
  cancelConfirmation: '取消确认',
  confirmCancelOrder: '订单将被取消，您确实要执行吗？',
  cancelOrder: '取消订单',
  paymentMethodMap1: '在线支付',
  paymentMethodMap2: '货到付款',
  paymentMethodMap3: '预付款',
  // -------------------------------------------
  packageStatusMap1: '待发货',
  packageStatusMap2: '运输中',
  packageStatusMap3: '派送中',
  packageStatusMap4: '已完成',
  packageStatusMap5: '已拒收',
  packageStatusMap6: '取消',
  packageStatusMap7: '已退回',
  // ----------------------------------------------
  shipOrderStatusMap1: '拣货',
  shipOrderStatusMap2: '拣货完成',
  shipOrderStatusMap3: '打包完成',
  shipOrderStatusMap4: '运输中',
  shipOrderStatusMap5: '派送中',
  shipOrderStatusMap6: '已完成',
  shipOrderStatusMap7: '已拒收',
  shipOrderStatusMap8: '取消',
  // -------------------------------------------
  saleOrderStatusMap1: '待支付',
  saleOrderStatusMap2: '待确认',
  saleOrderStatusMap3: '待发货',
  saleOrderStatusMap4: '运输中',
  saleOrderStatusMap5: '已签收',
  saleOrderStatusMap6: '补货中',
  saleOrderStatusMap7: '取消',
  saleOrderStatusMap8: '已拒收',
  saleOrderStatusMap9: '部分收货',
  // ------------------------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // ----------------------------------------
  operateTypeList1: '下单',
  operateTypeList2: '支付 ',
  operateTypeList3: '确认',
  operateTypeList4: '发货',
  operateTypeList5: '到达中转仓',
  operateTypeList6: '清关',
  operateTypeList7: '到达本地仓',
  operateTypeList8: '打包完成',
  operateTypeList9: '派送完成',
  operateTypeList10: '已收件',
  operateTypeList11: '关闭',
  operateTypeList12: '取消',
  operateTypeList13: '已拒收',
  // --------------------------------------------
  operatorIdList1: '买家',
  operatorIdList2: '卖家',
  operatorIdList3: '交易平台',
  operatorIdList4: '物流',
  operatorIdList5: '交易平台',
  // ---------------------------------------------
  time: '时间',
  operation: '操作',
  operatorId: '操作人id',
  from: '来源',
  so: '订单ID',
  payment: '支付方式',
  paymentStatus: '支付状态',
  unpaid: '未支付',
  paid: '已支付',
  userId: '用户ID',
  contactPhone: '联系电话',
  orderTime: '下单时间',
  // amount: '金额',
  amount: 'Item Total',
  discount: '折扣',
  postage: '运费',
  coinsRedeem: '积分抵扣',
  voucherRedeem: '优惠券抵扣',
  oldStatus: '前一个状态',
  status: '状态',
  // -----------------------------------
  columnShipInfo1: '发运单id',
  columnShipInfo2: '发运单编号',
  columnShipInfo3: '发运单状态',
  damaged: '损坏',
  discrepancy: '不符',
  noReason: '无理由',
  columnShipInfo4: '发运包ID',
  columnShipInfo5: '发运包编号',
  columnShipInfo6: '发运包状态',
  columnShipInfo7: '发运包生成时间',
  // -------------------------------------------
  columnOder1: '销售订单编号',
  columnOder2: '订单金额',
  columnOder3: '收件人',
  columnOder4: '国别',
  columnOder5: '省或大区',
  total: 'Total',
  due: 'Due',
  columnOder6: '城市',
  columnOder7: '区域',
  columnOder8: '地址',
  columnOder9: '联系电话',
  // --------------------------------------
  tableColumnSku1: 'Sku Id',
  tableColumnSku2: '供应商商品ID',
  tableColumnSku3: '促销价',
  tableColumnSku4: '售价',
  tableColumnSku5: '数量',
  tableColumnSku6: '可用数',
  tableColumnSku7: '金额',
  tableColumnSku8: '折扣',
  tableColumnSku9: '积分抵扣',
  tableColumnSku10: '优惠券抵扣',
  tableColumnSku11: '标题',
  tableColumnSku12: '规格',
  tableColumnSku13: '重量',
  tableColumnSku14: '供应商',
  // ---------------------------------
  errorTips1: '该商品从Dhaka退货仓发货，由Kilimall代处理',
  warningTips1: '【2204】SMS已关闭',
  warningTips2: '【2252】SMS发送失败',
  successTips1: 'SMS发送成功',
  delivered: '商品派送由',
  orderTrack: '订单跟踪'
}
